import { Capacitor } from "@capacitor/core"
import { Share } from "@capacitor/share"
import HTTPService from "../HTTPService"

// On native platforms, opens the OS share sheet with the room invitation link instead of a copy-link modal.
// Returns true when handled natively so callers can fall back to their existing web modal otherwise.
export const shareRoomInvitationLink = async (roomId: number, dialogTitle: string): Promise<boolean> => {
    if (!Capacitor.isNativePlatform()) {
        return false
    }

    try {
        const response = await HTTPService.get(`/get-invitation-link/${roomId}`)
        if (response.status !== 200 || !response.data?.link) {
            return false
        }

        await Share.share({
            url: response.data.link,
            dialogTitle,
        })
        return true
    } catch (error) {
        return false
    }
}
